import type { PersistedUi } from "./persistedUi";

const KEY = "cost-analyzer:named-scenarios:v1";
const MAX = 5;

export type NamedScenarioEntry = {
  id: string;
  name: string;
  snapshot: PersistedUi;
};

export function loadNamedScenarios(): NamedScenarioEntry[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const data = JSON.parse(raw) as unknown;
    if (!Array.isArray(data)) return [];
    const out: NamedScenarioEntry[] = [];
    for (const row of data) {
      if (!row || typeof row !== "object") continue;
      const o = row as Record<string, unknown>;
      const id = typeof o.id === "string" ? o.id : "";
      const name = typeof o.name === "string" ? o.name.trim() : "";
      const snap = o.snapshot;
      if (!id || !name || !snap || typeof snap !== "object") continue;
      out.push({ id, name, snapshot: snap as PersistedUi });
      if (out.length >= MAX) break;
    }
    return out;
  } catch {
    return [];
  }
}

function persist(list: NamedScenarioEntry[]) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* ignore */
  }
}

export function addNamedScenario(
  name: string,
  snapshot: PersistedUi,
  prev: NamedScenarioEntry[],
): NamedScenarioEntry[] {
  const trimmed = name.trim().slice(0, 80);
  if (!trimmed) return prev;
  const id =
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `ns-${Date.now()}`;
  const next = [{ id, name: trimmed, snapshot }, ...prev].slice(0, MAX);
  persist(next);
  return next;
}

export function removeNamedScenario(
  id: string,
  prev: NamedScenarioEntry[],
): NamedScenarioEntry[] {
  const next = prev.filter((x) => x.id !== id);
  persist(next);
  return next;
}
